<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="电话"
        v-model.trim="username"
        class="handle-input mr10"
      ></el-input>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="80px" align="center" label="序号" type="index">
        <template #default="scope">
          <span>{{ (data.current - 1) * 20 + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="username"
        label="注册电话"
        align="center"
      ></el-table-column>
      <el-table-column label="注册时间" align="center">
        <template #default="scope"
          >{{ $utils.formatDate(scope.row.applyTime, "yyyy-MM-dd") }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
      username: "",
    };
  },
  methods: {
    async getData(page) {
      const params = {
        currentPage: page,
        pageSize: 20,
        username: this.username,
      };
      this.$loading.start();
      const res = await this.$api.authe.getUnAuthe(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(data) {
      this.itemData = data;
      this.editVisible = true;
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.editVisible-dialog {
  img {
    width: 120px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      padding: 0;
      &:first-child {
        td {
          border-top: 1px solid #ebeef5;
        }
      }
      td {
        padding: 10px;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        &:first-child {
          width: 130px;
          border-left: 1px solid #ebeef5;
        }
      }
    }
  }
}
</style>